module.exports = __webpack_public_path__ + "static/media/HCMM375.5a907ba1.jpg";